import { dailyPayoutInformationQuery } from "@/api/reporting";
import { DataTable } from "@/components/data-table/DataTable";
import { DataTableBody } from "@/components/data-table/DataTableBody";
import { StyledLink } from "@/components/link/StyledLink";
import { PageWrapper } from "@/components/ui/PageWrapper";
import { formatDate } from "@common/utils/date";
import { formatDollars, formatWholeNumber } from "@common/utils/i18n";
import { Box } from "@givenwell/components";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { fallback, number, object, optional, pipe, string, toMinValue } from "valibot";

export const Route = createFileRoute("/admin/reports/$countryCode/daily-payouts/")({
  component: SupplierOnboardingProgressReportPage,
  validateSearch: object({
    q: fallback(optional(string()), ""),
    page: fallback(pipe(optional(number(), 1), toMinValue(1)), 1),
    "page-size": fallback(pipe(optional(number(), 100), toMinValue(10)), 100),
  }),
  beforeLoad: () => ({
    breadcrumb: "Daily Payouts",
  }),
});

function SupplierOnboardingProgressReportPage() {
  const { countryCode } = Route.useParams();

  const payoutInfoQuery = useQuery(dailyPayoutInformationQuery(countryCode));

  return (
    <PageWrapper title="Supplier — Daily Payouts">
      <Box css={{ spaceY: 16 }}>
        <DataTable>
          <DataTableBody
            data={payoutInfoQuery.data ?? []}
            status={payoutInfoQuery.status}
            rounded="full"
            columns={[
              {
                header: "Day",
                cell: row => {
                  return (
                    <StyledLink
                      to="/admin/reports/$countryCode/daily-payouts/detail"
                      params={{ countryCode }}
                      search={{ from: row.day_from, to: row.day_to }}
                    >
                      {formatDate(row.day)}
                    </StyledLink>
                  );
                },
              },
              {
                header: "# Payouts",
                cell: row => formatWholeNumber(row.number_of_payouts),
                css: { textAlign: "right" },
              },
              {
                header: "Average Payout",
                cell: row => formatDollars(row.average_payout, row.currency),
                css: { textAlign: "right" },
              },
              {
                header: "Total Payout",
                cell: row => formatDollars(row.total_payout, row.currency),
                css: { textAlign: "right" },
              },
            ]}
            dataKey={row => `${row.day}-${row.currency}`}
          />
        </DataTable>
      </Box>
    </PageWrapper>
  );
}
